// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"list_wrapper__0BZEl"};